import React from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table
} from 'reactstrap';
import { FaTrashAlt } from 'react-icons/fa';
import { PhoneCell } from 'components/FlexTable/components/cells/phone';

const ModalConfirmation = ({
  isOpen,
  clients,
  onConfirm,
  onCancel,
  onDelete
}) => {
  return (
    <Modal isOpen={isOpen} toggle={onCancel} size="lg">
      <ModalHeader toggle={onCancel}>Confirmar Seleção</ModalHeader>
      <ModalBody>
        <p>Você selecionou os seguintes clientes:</p>
        <Table hover>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Telefone</th>
              <th>Deletar</th>
            </tr>
          </thead>
          <tbody>
            {clients?.map((client) => (
              <tr key={client.id}>
                <td>{client.nome || client.name}</td>
                <td>
                  <PhoneCell phone={client.phoneNumber} ddi={client.ddi} />
                </td>
                <td>
                  <Button
                    color="danger"
                    onClick={() => onDelete(client.id)}
                    size="sm"
                    style={{ marginLeft: '10px' }}
                  >
                    <FaTrashAlt />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={onConfirm}>
          Confirmar
        </Button>
        <Button color="secondary" onClick={onCancel}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalConfirmation;
